import PropTypes from 'prop-types'

import { isBlank } from 'utils'

import Text from 'components/Text'

import { Option, OptionInput, OptionLabel, Root } from './ProductOptions.style'

const ProductOptions = ({
  name: optionName,
  options,
  enabledOptions,
  value,
  isDisabled: _isDisabled,
  onChange = () => {},
}) => {
  const handleChange = ({ target: { value } }) => {
    onChange(optionName, value)
  }

  if (typeof enabledOptions === 'undefined') enabledOptions = options

  if (isBlank(options)) return null

  return (
    <Root>
      {options.map(({ id, name }) => {
        const checked = name === value

        return (
          <Option key={id}>
            <OptionInput
              name={optionName}
              key={id}
              id={id}
              type="radio"
              value={name}
              checked={checked}
              onChange={handleChange}
              data-disabled={!enabledOptions.includes(name)}
            />
            <OptionLabel htmlFor={id}>
              <Text font="proxima" transform="uppercase" tracking="wide" size="sm">
                {name}
              </Text>
            </OptionLabel>
          </Option>
        )
      })}
    </Root>
  )
}

ProductOptions.propTypes = {
  name: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func,
}

ProductOptions.defaultProps = {}

export default ProductOptions
